import { Box } from "@mui/material";
import React,{useEffect} from "react";
import Form from "./Form";
import Table from "./Table";
import { useSelector,useDispatch } from "react-redux";
import { setState} from "../analyzeSlice";

export default function Scenario() {
	const state = useSelector((store) => store.analyze);
	const { scenarioChartDataPrepared } = state;
	const dispatch=useDispatch();
    useEffect(()=>{
		dispatch(setState("showTableData",false));
		dispatch(setState("showCustomerIncludedExcluded",false));
		dispatch(setState("selectedScenarioName",""));
		dispatch(setState("selectedScenarioID",""));
		},[]);
			
	return (
		<Box>
			<Form />
			{scenarioChartDataPrepared !== null ? <Table /> : null}
		</Box>
	);
}
